import { Resources } from '../../resource';
import LeaderboardCyclesList from './List';
import { FaGift } from 'react-icons/fa';
import { ResourceOptions } from 'react-admin';
export { default as list } from './List';

export const name = Resources.redpacketLeaderboardCycles;
export const icon = FaGift;
export const options: ResourceOptions = {
  label: 'Leaderboard Cycles',
};
